import { getAuth } from 'firebase/auth';
import { collection, getDocs, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { db } from '../../firebase';

function UserList() {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const auth = getAuth();
    const user = auth.currentUser;

    useEffect(() => {
        const fetchPayments = async () => {
          if (user) {
            const q = query(
              collection(db, "Users"), where("roles", "==", "Utilisateur")
            );
            const querySnapshot = await getDocs(q);
            const paymentsData = querySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setUsers(paymentsData);
            setLoading(false);
          }
        };
    
        fetchPayments();
      }, [user]);

      const formatDate = (seconds) => {
        const date = new Date(seconds * 1000);
        const options = { day: "numeric", month: "long", year: "numeric" };
        const dateString = date.toLocaleDateString("fr-FR", options);
        const timeString = date.toLocaleTimeString("fr-FR", {
          hour: "2-digit",
          minute: "2-digit",
        });
        return `${dateString} à ${timeString}`;
      };
    
      const formatHeure = (seconds) => {
        const date = new Date(seconds * 1000);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${hours}:${minutes}`;
      };
    
      const formatSimpleDate = (seconds) => {
        const date = new Date(seconds * 1000);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      };
  return (
    <div className='h-screen'>
      <Helmet>
        <title>Transactions</title>
      </Helmet>
      <h1 className="poppins-bold text-3xl md:text-5xl text-gray-900 text-center">
        Listes des utilisateurs
      </h1>
      <section class="relative mt-5">
        <div class="w-full max-w-7xl px-3 lg-6 space-y-2 mx-auto">
          <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="overflow-x-auto">
              <table className="table">
                {/* head */}
                <thead className="text-gray-800 text-sm uppercase poppins-semibold">
                  <tr>
                    <th>Utilisateur</th>
                    <th>E-mail</th>
                    <th>Téléphone</th>
                    <th>Ville</th>
                    <th>Pays</th>
                    <th>Date création</th>
                    <th>Filleul</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                {loading ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={8}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      <span className="loading loading-spinner loading-lg"></span>
                    </td>
                  </tr>
                ) : users.length === 0 ? (
                  <tr className="bg-white border-b hover:bg-gray-50">
                    <td
                      colSpan={8}
                      className="text-center py-3 poppins-semibold uppercase"
                    >
                      Aucune utilisateur enregistré
                    </td>
                  </tr>
                ) : (
                    users.map((user) => (
                  <tr key={user.id} className="text-gray-600">
                    <td className="poppins-semibold text-pink-600">{user.firstName} {user.lastName}</td>
                    <td>{user.email}</td>
                    <td>{user.phone}</td>
                    <td>{user.city}</td>
                    <td>{user.country}</td>
                    <td>{formatSimpleDate(user.dateCreated)}</td>
                    <td>{user.referrals.length}</td>
                    <td>
                      <div className="badge badge-success text-white text-xs text-nowrap">
                        Activé
                      </div>
                    </td>
                    <td>Edit</td>
                  </tr>
                  ))
                )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default UserList